import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import {
  registration,
  addCustomer,
  authentication,
  receivedCurr,
  verify,
  resetPin,
  resetPass,
  forgotPass,
  changePass,
  forgotPin,
  nationality,
  getRate,
  rateCharges,
  getCustDetails,
  currency,
  transcation,
  beneficary,
  addBeneficiary,
  purpose,
  source,
  paymentMode,
  branches,
  country,
  newsEvent,
  services,
  getAgentDetails,
  serviceProvider,
  typeDetails,
  saveRemit,
  getTransactionRef,
  getTransferRate,
  currencyCalc,
  getRemitCurrency,
  getRemitCountry,
  getBankBranch,
  getAllBankBranch,
  uploadMedia,
  cancelTransaction,
  getRelationShip,
  aboutUs,
  getIDType,
  getDrawingBank,
  getProfession,
  getValidID,
  setCredential,
  getAllBanks,
  lastPage,
} from './_reducer';

const rootReducer = combineReducers({
  registration,
  addCustomer,
  authentication,
  receivedCurr,
  verify,
  resetPin,
  resetPass,
  forgotPass,
  changePass,
  forgotPin,
  nationality,
  getRate,
  rateCharges,
  getCustDetails,
  currency,
  transcation,
  beneficary,
  addBeneficiary,
  purpose,
  source,
  paymentMode,
  branches,
  country,
  newsEvent,
  services,
  getAgentDetails,
  serviceProvider,
  typeDetails,
  saveRemit,
  getTransactionRef,
  getTransferRate,
  currencyCalc,
  getRemitCurrency,
  getRemitCountry,
  getBankBranch,
  getAllBankBranch,
  uploadMedia,
  cancelTransaction,
  getRelationShip,
  aboutUs,
  getIDType,
  getDrawingBank,
  getProfession,
  getValidID,
  setCredential,
  getAllBanks,
  lastPage,
});

export default rootReducer;
